import { BitfSearchApiRequestPart } from '@bitf/core/api-call-state/bitf-search-api-request-part.builder';

export class BitfStrapiSearchApiRequestPart extends BitfSearchApiRequestPart {
  constructor(params = {}) {
    super(params);
  }
}
